<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
<!--                    <el-form-item label="">-->
<!--                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>-->
<!--                    </el-form-item>-->
                    <!--<el-form-item label="名称">-->
                        <!--<el-input v-model="formInline.userGroupName" placeholder="输入名称查询"></el-input>-->
                    <!--</el-form-item>-->
                    <!--<el-form-item label="描述">-->
                        <!--<el-input v-model="formInline.groupDesc" placeholder="输入描述查询"></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="活动名称">
                        <el-select v-model="formInline.activeNo" clearable filterable placeholder="活动名称">
                            <el-option v-for="item in items"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getList">查询</el-button>
                        <el-button type="success" @click="add()" class="header-btn">新建</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="activeIndexId" width="80"></el-table-column>
            <el-table-column label="活动名称" prop="activeName" width="190"></el-table-column>
            <el-table-column label="活动类型" prop="activeType" width="150"></el-table-column>
            <el-table-column label="描述" prop="activeIndexDesc" width="230"></el-table-column>
            <el-table-column label="排序" prop="sort" width="80"></el-table-column>
            <el-table-column label="活动状态" prop="statusName" width="200">
            </el-table-column>
            <el-table-column label="url" prop="activeUrl" width="350"></el-table-column>
            <el-table-column label="操作" fixed="right" >
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="danger"  size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="活动首页配置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="活动">
                    <el-select v-model="model.activeNo" @change="onChange()" filterable clearable  placeholder="活动">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                    <span style="color: red">活动必须选择</span>
                </el-form-item>
                <el-form-item label="描述" prop="activeIndexDesc">
                    <el-input v-model="model.activeIndexDesc" placeholder="请输入描述"></el-input>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="排序">
                    <el-input-number v-model="model.sort"  :min="1" :max="1000" placeholder=""></el-input-number>
                </el-form-item>
                <el-form-item label="url" prop="activeUrl">
                    <el-input v-model="model.activeUrl" placeholder="请输入连接地址"></el-input>
                    <span style="color: red">*要跳转的页面连接地址(url)</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getActiveForOption,
        saveActiveIndexApi,
        getActivePageApi,
        deletActiveIndexApi,
        getActiveIndexListApi,
        getActive,
        getItems
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal:0,
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    activeNo:""
                },
                model: {
                    activeIndexId:'',
                    activeNo: '',
                    activeIndexDesc: '',
                    sort:1,
                    activeUrl:''
                },
                loading: true,
                activeList:[]
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.handleLoadActiveList(5);
            this.getList();
            this.getActiveList();
        },
        methods: {
            getList(){
                //查询模板列表
                getActiveIndexListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getActiveList(){
                getActiveForOption({}).then((res) => {
                    this.activeList = res.data.value;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleLoadActiveList(data){
                //商品
                getItems({itemType:data}).then((res) => {
                    console.log(res);
                    this.items = res.data;
                });
            },
            add(){
                this.model = {
                    activeNo: '',
                    activeIndexDesc: '',
                    sort: 1,
                    activeUrl:''
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    activeIndexId: row.activeIndexId,
                    activeNo: row.activeNo,
                    activeIndexDesc: row.activeIndexDesc,
                    activeUrl:row.activeUrl,
                    sort:row.sort
                };
                this.showDialog = true;
            },
            save(row){
                //保存应用
                if(this.model.activeNo==''){
                    this.$message({
                        message: '活动必须选择',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.activeIndexDesc==''){
                    this.$message({
                        message: '描述必须输入',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.activeUrl==''){
                    this.$message({
                        message: '跳转url必须输入',
                        type: 'error'
                    });
                    return;
                }
                this.loading=true;
                saveActiveIndexApi(this.model).then((res) => {
                    this.loading=false;
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deletActiveIndexApi({activeIndexId:row.activeIndexId}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            onChange(){
                this.loading = true;
                getActivePageApi({activeNo: this.model.activeNo}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        if (res.data.value != null) {
                            this.model.activeUrl= res.data.value.activeUrl;
                        }
                    }
                });
            },
            formatDate(datetime) {
                if(datetime==null){
                    return '';
                }else {
                    var date = new Date(datetime);
                    var year = date.getFullYear(),
                        month = ("0" + (date.getMonth() + 1)).slice(-2),
                        sdate = ("0" + date.getDate()).slice(-2),
                        hour = ("0" + date.getHours()).slice(-2),
                        minute = ("0" + date.getMinutes()).slice(-2),
                        second = ("0" + date.getSeconds()).slice(-2);
                    // 拼接
                    var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
                    // 返回
                    return result;
                }
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/active/activeIndex.vue